module.exports = __webpack_public_path__ + "media/checkmarks/white-checkmark-blue-bg-def13521.svg";